import { useState } from "react";
import { useModal } from "../_providers/ModalProvider";

const SingleInputModal = (props: {onCreate: (value: string) => void}) => {
    const [value, setValue] = useState<string>("");

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <input
                type="text"
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <button onClick={() => props.onCreate(value)}>Create</button>
        </div>
    )
}
export default SingleInputModal;